import Logo from '../components/Logo'
import { 
    TextL,
 } from '../components'
import {
    WalletButton
} from '../ethComponents'

import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

function AppBar() {
    return (
        <>
            <MuiAppBar >
                <Container sx={{marginTop:'10px'}}>
                    <Stack direction='row' justifyContent='space-between' alignItems='center'>
                        <Logo size='1.4'> <TextL style={{marginLeft: '10px'}}> {process.env.TITLE} </TextL></Logo>
                        <WalletButton
                            buttonType={{
                                size: 'small',
                                type: 'b'
                            }}
                        />
                    </Stack>
                </Container>
            </MuiAppBar>
            <Toolbar />
        </>
    );
}

export default AppBar
